@if (filter && values) {
    <table style="width: 100%" (keypress.control.enter)="enterPress.emit()">
        @for (f of filter.fields; track f?.id || f?.name; let ff = $first, l = $last) {

             @if (f && !f.hidden) {
                <tr nz-tooltip
                    [nzTooltipTitle]="filterHelpTpl"
                    [nzTooltipMouseEnterDelay]="700"
                    nzTooltipOverlayClassName="vz-tooltip-light"
                    [nzTooltipPlacement]="['right', 'top']"
                    [nzTooltipTrigger]="_mobile() ? null : 'hover'">
                    @if (!_mobile()) {
                        <td class="txt-l no-wrap" width="1px">{{ f.name }}</td>
                    }

                    <td class="layout" [style.margin-bottom.px]="_mobile() ?  8 : 0">
                        <div class="layout flex" [ngClass]="_mobile() ? 'vertical' : 'end'">
                            @if (_mobile()) {
                                <b>{{ f.name }}:</b>
                            }
                            @switch (f.type) {
                                @case (FFT.String) {
                                    <ng-container [ngTemplateOutlet]="tplString" [ngTemplateOutletContext]="{ $implicit: f, ff }" />
                                }
                                @case (FFT.String) {
                                    <ng-container [ngTemplateOutlet]="tplString" [ngTemplateOutletContext]="{ $implicit: f, ff }" />
                                }
                                @case (FFT.Date) {
                                    <ng-container [ngTemplateOutlet]="tplDate" [ngTemplateOutletContext]="{ $implicit: f, ff }" />
                                }
                                @case (FFT.DateOrUnset) {
                                    <ng-container [ngTemplateOutlet]="tplDate" [ngTemplateOutletContext]="{ $implicit: f, ff }" />
                                }
                                @case (FFT.Users) {
                                    <ng-container [ngTemplateOutlet]="tplUsersOrGroups" [ngTemplateOutletContext]="{ $implicit: f, ff, wg: false }" />
                                }
                                @case (FFT.UsersOrGroups) {
                                    <ng-container [ngTemplateOutlet]="tplUsersOrGroups" [ngTemplateOutletContext]="{ $implicit: f, ff, wg: true }" />
                                }
                                @case (FFT.Projects) {
                                    <ng-container [ngTemplateOutlet]="tplProjects" [ngTemplateOutletContext]="{ $implicit: f, ff }" />
                                }
                                @case (FFT.Orgs) {
                                    <ng-container [ngTemplateOutlet]="tplOrgs" [ngTemplateOutletContext]="{ $implicit: f, ff }" />
                                }
                                @case (FFT.Enum) {
                                    @for (kv of f.typeData; track kv[0]) {
                                        <label
                                            [class.ml05]="$first && _mobile()"
                                            nz-checkbox
                                            [(ngModel)]="values![f.id][kv[0]]"
                                            (ngModelChange)="updateValues()">
                                            {{ kv[1] }}
                                        </label>
                                    }
                                }
                                @case (FFT.Flag) {
                                    <label nz-checkbox [(ngModel)]="values![f.id]" (ngModelChange)="updateValues()"></label>
                                }
                                @case (FFT.Tags) {
                                    <ng-container [ngTemplateOutlet]="tplTags" [ngTemplateOutletContext]="{ $implicit: f, ff }" />
                                }
                                @default {
                                    <span class="txt-err op05">неизвестный тип фильтра: {{f.type | json }}</span>
                                }
                            }
                        </div>
                    </td>

                </tr>
            }

            <ng-template #filterHelpTpl>
                <div class="layout vertical" style="width: 400px">
                    <b class="txt">{{ f!.name }}</b>
                    @if (f?.desc) {
                        <i class="txt-l">{{ f!.desc }}</i>
                    }
                </div>
            </ng-template>

        }
    </table>
}

<ng-template let-f let-first="ff" #tplString>
    <input class="ph025 bc" style="border-bottom: 1px solid"
        [(ngModel)]="values![f.id]"
        (ngModelChange)="updateValues()"
        [aFocus]="first ? 100 : -1"
        nz-input
        [nzVariant]="_mobile() ? 'outlined' : 'borderless'"
        (keyup.enter)="enterPress.emit()">
</ng-template>

<ng-template let-f let-first="ff" #tplDate>
    <nz-select class="bc" style="border-bottom: 1px solid" [(ngModel)]="values![f.id].p" (ngModelChange)="updateValues()" [nzBorderless]="!_mobile()">
        <nz-option nzLabel=">" nzValue=">" />
        <nz-option nzLabel="<" nzValue="<" />
        <nz-option nzLabel="=" nzValue="=" />
        @if (f.type == FFT.DateOrUnset) {
            <nz-option nzLabel="?" nzValue="?" (click)="values![f.id].dt = null" />
        }
    </nz-select>
    <nz-select class="bc" style="border-bottom: 1px solid; min-width: 110px" [(ngModel)]="values![f.id].tpl" (ngModelChange)="updateValues()" [nzBorderless]="!_mobile()" nzAllowClear nzPlaceHolder="Шаблон">
        <nz-option nzLabel="Вчера" nzValue="yesterday" />
        <nz-option nzLabel="Сегодня" nzValue="today" />
        <nz-option nzLabel="Завтра" nzValue="tomorrow" />
        <nz-option nzLabel="Эта неделя" nzValue="week" />
        <nz-option nzLabel="Этот месяц" nzValue="month" />
    </nz-select>
    <nz-date-picker
        class="flex"
        style="border-bottom: 1px solid var(--vz-borderColor) !important"
        [class.hidden]="values![f.id].p == '?' || !!values![f.id].tpl"
        [nzBorderless]="!_mobile()"
        [(ngModel)]="values![f.id].dt"
        (ngModelChange)="updateValues()"
        [nzDisabled]="values![f.id].p == '?'">
    </nz-date-picker>
    @if (values![f.id].p == '?') {
        <small class="self-center ml05 txt-p">Срок не установлен</small>
    }
</ng-template>

<ng-template let-f let-first="ff" let-withGroups="wg" #tplUsersOrGroups>
    <person-or-group-select
        class="bc flex"
        style="border-bottom: 1px solid"
        [(ngModel)]="values![f.id]"
        (ngModelChange)="updateValues()"
        placeholder=""
        multiple="true"
        [persons]="persons"
        [groups]="withGroups ? groups : undefined"
        [vzVariant]="_mobile() ? 'outlined' : 'borderless'" />
</ng-template>

<ng-template #tplSelectItem let-item>
    <vz-avatar
        class="ml-05"
        style="display: inline-block;"
        [style.margin-top.px]="1"
        [style.margin-right.px]="4"
        [uid]="item.nzValue.id"
        [size]="20"
        withName="true"
        [type]="isGroup[item.nzValue.id] ? 'group' : 'user'" />
</ng-template>

<ng-template let-f let-first="ff" #tplProjects>
    <vz-project-select
        class="bc flex"
        style="border-bottom: 1px solid"
        [(ngModel)]="values![f.id]"
        (ngModelChange)="updateValues()"
        [vzVariant]="_mobile() ? 'outlined' : 'borderless'"
        placeholder=""
        multiple="true" />
</ng-template>

<ng-template let-f let-first="ff" #tplOrgs>
    <nz-select class="bc flex"
        style="border-bottom: 1px solid"
        [(ngModel)]="values![f.id]"
        (ngModelChange)="updateValues()"
        [nzBorderless]="!_mobile()"
        nzMode="multiple"
        [nzMaxMultipleCount]="10"
        [compareWith]="compareById"
        nzShowSearch
        nzAllowClear>
        @for (item of orgs; track item.id) {
            <nz-option nzCustomContent [nzLabel]="item.name" [nzValue]="item">
                <vz-avatar style="display: inline-block;" [item]="item" size="20" withName="true" type="org" />
            </nz-option>
        }
    </nz-select>
</ng-template>

<ng-template let-f let-first="ff" #tplTags>
    <vz-tags-select
        class="bc flex"
        style="border-bottom: 1px solid"
        [(ngModel)]="values![f.id]"
        (ngModelChange)="updateValues()"
        (drawerOpened)="tagsDrawerOpened.emit($event)"
        [showAllProjects]="true"
        [vzVariant]="_mobile() ? 'outlined' : 'borderless'"
        placeholder="" />
</ng-template>
